<template>
  <div class="shippers-window">
        <search-box :returnData="carriersData" @search-carrier="searchCarrier"></search-box>
        <div class="shippers-window_no color99 size12" v-show="noSearch && !searchData.length">{{$t('page.not_find_carrier')}}</div>
        <div class="shippers-window_box marTop40" v-show="searchData.length">
          <shippers-box
            v-for="(item, index) in searchData"
            v-show="item.isSupported"
            :key="index"
            :shippers-data="item"
            @shippers-close="close">
          </shippers-box>
        </div>
        <el-tabs v-show="!searchData.length && !noSearch"  v-model="activeName">
          <!-- <el-tab-pane :label="$t('page.common_carrier')" :name="$t('page.common_carrier')">
            <shippers-used
              :shippers-data="shippersCookies"
              @shippers-close="close"
              @shippers-empty="empty"></shippers-used>
          </el-tab-pane> -->
          <el-tab-pane :label="$t('page.global_postal_service')" :name="$t('page.global_postal_service')">
            <global-post
              :letter-data="Postal"
              @shippers-close="close"
              @shippers-empty="empty"></global-post>
          </el-tab-pane>
          <el-tab-pane :label="$t('page.international_carrier')" :name="$t('page.international_carrier')">
            <international-shippers
              :shippers-data="InternationalCarrier"
              @shippers-close="close"
              @shippers-empty="empty"></international-shippers>
          </el-tab-pane>
          <el-tab-pane :label="$t('page.chinese_carrier')" :name="$t('page.chinese_carrier')">
            <china-shippers
              :shippers-data="ChinaCarrier"
              @shippers-close="close"
              @shippers-empty="empty"></china-shippers>
          </el-tab-pane>
        </el-tabs>
        <!--<div class="back_button" v-show="backShow">-->
          <!--<el-button size="small" @click="closeback">{{$t('page.return')}}</el-button>-->
        <!--</div>-->
        <div class="match_button" v-show="backShow">
          <el-button type="primary" size="small" @click="backQuick">{{$t('page.has_found_carrier')}}</el-button>
        </div>
  </div>
</template>

<script>
  import searchBox from '@/components/searchBox.vue'
  import shippersUsed from '@/components/shippers/shippersUsed.vue'
  import internationalShippers from '@/components/shippers/internationalShippers.vue'
  import globalPost from '@/components/shippers/globalPost.vue'
  import chinaShippers from '@/components/shippers/chinaShippers.vue'
  import {carriers} from '@/api/getSearch.js'
  import {pinyinPost} from '@/common/pinyin.js'
  import shippersBox from '@/components/shippers/shippersBox.vue'

  export default {
  data () {
    return {
      activeName: this.$t('page.global_postal_service'),
      carriersData: [],
      shippersCookies: [],
      Postal: [],//全球邮政数据
      InternationalCarrier: [],//国际运输商数据
      ChinaCarrier: [],//中国运输商数据
      searchData: [],
      noSearch: false
    }
  },
  props: {
    shippersShow: {
      type: Boolean,
      default: false
    },
    backShow: {
      type: Boolean,
      default: true
    }
  },
  components: {
    searchBox,
    shippersUsed,
    internationalShippers,
    globalPost,
    chinaShippers,
    shippersBox
  },
  created () {
    let vm = this
    // if (!LocalStorage.get('shippers-all')) {
      carriers().then((res) => {
        localStorage['shippers-all'] = JSON.stringify(res)
        vm.carriersData = res
        res.forEach (item=> {
          if (item.carrierType === 'Postal') {
            vm.Postal.push(item)
          }
          else if (item.carrierType === 'InternationalCarrier') {
            vm.InternationalCarrier.push(item)
          }
          else if (item.carrierType === 'ChinaCarrier') {
            vm.ChinaCarrier.push(item)
          }
        })
        this.Postal = pinyinPost(this.Postal,vm)
        this.Postal[0].click = true
        this.shippersCookies = localStorage['shippers-key'] || []
      })
    // } else {
    //   let res = LocalStorage.get('shippers-all')
    //   vm.carriersData = res
    //   res.map(function (item, index) {
    //     if (item.carrierType === 'Postal') {
    //       vm.Postal.push(item)
    //     } else if (item.carrierType === 'InternationalCarrier') {
    //       vm.InternationalCarrier.push(item)
    //     } else if (item.carrierType === 'ChinaCarrier') {
    //       vm.ChinaCarrier.push(item)
    //     }
    //   })
    //   this.Postal = pinyinPost(this.Postal)
    //   this.Postal[0].click = true
    //   this.shippersCookies = LocalStorage.get('shippers-key') || []
    // }
  },
  mounted () {

  },
  methods: {
    closeback() {
      this.$emit('close')
    },
    close () {
      this.$emit('shippers-close')
    },
    empty () {
      this.$emit('shippers-empty')
    },
    searchCarrier (carriers) {
      if (carriers === this.$t('page.not_find_carrier')) {
        this.noSearch = true
        this.searchData = []
      } else {
        this.searchData = carriers
        this.noSearch = false
        // console.log('searchData', this.searchData)
      }
    },
    backQuick () {
      this.$emit('backQuick')
    }
  }
}
</script>

<style scoped>
  .shippers-window {
    min-height: 370px;
  }
  .detail {
    width: 800px;
     /*margin-left: -400px;*/
     /*top: 200px;*/
     height: 460px;
  }
  .head {
    background-color: #1F2A33!important;
    color: #fff!important;
  }
  .el-icon-close {
    color: #fff!important;
  }
  .shippers-window_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    max-height: 370px;
    overflow: auto;
  }
  .shippers-window_no {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 230px;
  }
  .back_button {
    position: absolute;
    top: 69px;
    right: 20px;
  }
  .match_button {
    position: absolute;
    top: 69px;
    right: 20px;
  }
  .shippers-window /deep/ .el-dialog {
    min-height: 500px;
  }
  .shippers-window /deep/ .el-tabs__header {
    margin: 0;
  }
  .shippers-window /deep/ .el-tabs__content {
    height: 370px;
  }
  .shippers-window /deep/ .el-dialog__body {
    padding: 10px 20px;
  }
  .shippers-window /deep/ .el-dialog__header {
    background-color: #003a9b;
    padding: 20px;
  }
  .shippers-window /deep/ .el-dialog__title {
    color: #fff;
  }
  .shippers-window /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
  .shippers-window /deep/ .el-dialog__headerbtn {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/new/shippersWindow.vue